export default __webpack_public_path__ + "static/media/cart-full.f7e873a5.svg";